<template>
    <div style="display: none">
        <input name="mapData" type="hidden" :value="JSON.stringify(toSaveParams)">
        <input v-if="$root.env === 'admin'" name="adminMapData" type="hidden" :value="JSON.stringify(toSaveParams)">
    </div>
</template>

<script>
    export default {
        name: "TxToSaveParams",
        props: {
            toSaveParams: {},
        },
    }
</script>

<style scoped>

</style>